// extracted by mini-css-extract-plugin
export default {"ordermodalmain":"returnorders_ordermodalmain__Vrye5","overlayordermodal":"returnorders_overlayordermodal__o9iCG"};